import { Component, inject } from '@angular/core';
import { ConsumableTypeService } from '../proxy/general/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  ConsumableTypeCreateDto,
  ConsumableTypeDto,
  ConsumableTypeExcelDownloadDto,
  ConsumableTypeUpdateDto,
} from '../proxy/general/dtos/consumable-type';
import { CONSUMABLETYPE_CONFIG, CONSUMABLETYPE_FIELDS } from './consumable-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-consumable-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, ConsumableTypeService, ConfirmationService],
  templateUrl: './consumable-type.html',
  styleUrl: './consumable-type.scss',
})
export class ConsumableType extends BaseCrudComponent<
  ConsumableTypeDto,
  ConsumableTypeCreateDto,
  ConsumableTypeUpdateDto,
  ConsumableTypeExcelDownloadDto
> {
  service = inject(ConsumableTypeService);
  config = CONSUMABLETYPE_CONFIG;
  fields = CONSUMABLETYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: ConsumableTypeDto): ConsumableTypeUpdateDto {
    return {
      name: data.name,
      code: data.code,
      mustBeSentToSap: data.mustBeSentToSap,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'ConsumableType';
  }
}
